import request from '@/utils/request'

export function getOrgCapacityHealthOverview () {
  return request({
    url: '/addon/orgCapacityHealth/overview',
    method: 'get'
  })
}
